import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Typography, Form } from 'antd';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import ProfileForm from '@/components/Settings/Profiles/ProfileForm';
import { PageProps } from '@/types/PageProps';
import { useCreateProfile } from '@/core/domain/enterprise/Profiles/Profiles.hooks';
import SpaceForButton from '@/components/_common/SpaceForButtons';

const { Title } = Typography;

const CreateProfilePage = ({ route }: PageProps) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [checkeds, setCheckeds] = useState<number[]>([]);

  const mutation = useCreateProfile();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();

      const obj = {
        ...values,
        rolesId: checkeds,
      };

      const result = await mutation.mutateAsync(obj);

      history.push(`/app/settings/profiles/${result.id}`);
    } catch {}
  };

  return (
    <div className="page">
      <div className="page-header">
        <Title level={3}>
          <FormattedMessage id={route.name} />
        </Title>

        <div className="actions">
          <SpaceForButton>
            <Button
              type="primary"
              loading={mutation.isLoading}
              onClick={handleSaveClick}
            >
              Criar
            </Button>
          </SpaceForButton>
        </div>
      </div>

      <ProfileForm
        form={form}
        roleIds={checkeds}
        onChangeRoleIds={setCheckeds}
        creation
      />
    </div>
  );
};

CreateProfilePage.propTypes = {
  route: PropTypes.object.isRequired,
};

export default CreateProfilePage;
